import {Component, OnInit, ViewChild} from '@angular/core';
import {MiniItem} from "../../../framework/model/core/items/miniitem";
import {ModelProvider} from "../../../framework/providers/modelProvider/ModelProvider";
import {IonSearchbar} from "@ionic/angular";
import {Events} from "../../../framework/providers/events";
import {BusinessService} from "../../services/BusinessService";

@Component({
    selector: 'app-search',
    templateUrl: './search.page.html',
    styleUrls: ['./search.page.scss'],
})
export class SearchPage implements OnInit {

    public searchText: string;
    public models: Array<MiniItem> = [];
    public options: object = {'search_auto_focus':true};


    constructor(public modelProvider: ModelProvider, public events: Events, public businessService:BusinessService) {
    }

    ngOnInit() {
    }

    ionViewDidEnter() {
        // setTimeout(() => {
        //     this.searchbar.setFocus();
        // });
    }

    search() {
        if (!this.searchText || this.searchText == '') return;
        // this.modelProvider.list('miniItem', {'search':this.searchText}).then((res)=>{
        //   this.models = res['models'];
        // })
        this.events.publish(this.options['prefix'] + '_updateItemsFilter', {'search': this.searchText});
    }
}
